import { Card, CardContent, Typography } from '@mui/material'
import { LineChart } from '@mui/x-charts/LineChart'
import { MonthlyLeadTime } from '@src/types/leadtime'
import { useTranslation } from 'react-i18next'

interface LeadTimeChartProps {
  monthlyData: MonthlyLeadTime[]
}

const LeadTimeChart = ({ monthlyData }: LeadTimeChartProps) => {
  const { t } = useTranslation()

  if (monthlyData.length === 0) {
    return (
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="body1" color="textSecondary">
            {t('leadTime.chart.noData')}
          </Typography>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('leadTime.chart.title')}
        </Typography>
        <LineChart
          xAxis={[
            {
              scaleType: 'band',
              data: monthlyData.map((m) => m.monthName),
              tickInterval: monthlyData.map((m) => m.monthName),
              label: t('leadTime.chart.xAxis'),
            },
          ]}
          yAxis={[
            {
              min: 0,
            },
          ]}
          series={[
            {
              data: monthlyData.map((m) => m.averageDays),
              label: t('leadTime.chart.averageLabel'),
              curve: 'linear',
            },
            {
              data: monthlyData.map((m) => m.medianDays),
              label: t('leadTime.chart.medianLabel'),
              curve: 'linear',
            },
          ]}
          height={400}
          margin={{ bottom: 80 }}
        />
      </CardContent>
    </Card>
  )
}

export default LeadTimeChart
